var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"error"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGlobalNotification),expression:"showGlobalNotification"}],staticClass:"error-alert"},[_c('div',{staticClass:"alert",class:`alert-${_vm.globalNotificationType}`,attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.globalNotificationMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }